import React from 'react';
import { Box } from '@mui/material';
import { W86_PANEL_CLASS } from '../NodeUI/nodeUiStyles';

const CustomPaper = React.forwardRef(
  (
    {
      children,
      className,
      style,
      sx,
      elevation, // Will be ignored since we're not using elevation
      hidden,
      overflowVisible = false,
      ...other
    },
    ref
  ) => {
    const baseStyles = {
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '8px',
      padding: '16px',
      boxSizing: 'border-box',
      overflow: overflowVisible ? 'visible' : 'hidden',
      ...style,
    };

    const combinedClassName = [W86_PANEL_CLASS, overflowVisible && 'w86-panel--overflow-visible', className]
      .filter(Boolean)
      .join(' ');

    const combinedSx = {
      ...baseStyles,
      ...sx,
    };

    return (
      <Box ref={ref} className={combinedClassName} sx={combinedSx} hidden={hidden} {...other}>
        {children}
      </Box>
    );
  }
);

CustomPaper.displayName = 'CustomPaper';

export default CustomPaper;
